import { render, staticRenderFns } from "./SystemTodoModal.vue?vue&type=template&id=57ca6850&scoped=true"
import script from "./SystemTodoModal.vue?vue&type=script&lang=js"
export * from "./SystemTodoModal.vue?vue&type=script&lang=js"
import style0 from "./SystemTodoModal.vue?vue&type=style&index=0&id=57ca6850&prod&lang=css"
import style1 from "./SystemTodoModal.vue?vue&type=style&index=1&id=57ca6850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca6850",
  null
  
)

export default component.exports